import useButtonFavorite from 'hooks/useButtonFavorite'
import cn from 'classnames'
import ButtonIcon from 'components/ButtonIcon'
import ModalSupprimerFavoris from './components/ModalSupprimerFavoris'

interface Props {
  uid: string
  className?: string
}

const defaultProps = {
  className: undefined,
}

const ButtonFavorite = ({ uid, className }: Props): JSX.Element => {
  const {
    active,
    toggleActive,
    loading,
    showModalSupprimerFavoris,
    confirmDeleteFromFavoris,
    cancelDeleteFromFavoris,
  } = useButtonFavorite(uid)

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    toggleActive()
  }

  const googleTagFavori =
    process.env.REACT_APP_GOOGLE_TAG_FAVORI_BIEN_A_VENDRE || ''

  return (
    <>
      <ButtonIcon
        icon="heart"
        active={active}
        disabled={loading}
        loading={loading}
        className={cn(
          'button-favorite',
          className,
          !active ? googleTagFavori : ''
        )}
        onClick={handleClick}
      />
      <ModalSupprimerFavoris
        show={showModalSupprimerFavoris}
        onCancel={cancelDeleteFromFavoris}
        onConfirm={confirmDeleteFromFavoris}
      />
    </>
  )
}

ButtonFavorite.defaultProps = defaultProps
export default ButtonFavorite
